import {
  ContextMenuItem,
  ContextMenuSeparator,
} from '~/sotano-kit/primitives/context-menu'
import { ContextMenuAction } from '~/sotano-kit/primitives/tree'

export const TabContextMenuActions = ({
  actions,
}: {
  actions: ContextMenuAction[]
}) => {
  return (
    <>
      {actions.map((action, i) => {
        if (action.type === 'separator') {
          return <ContextMenuSeparator key={i} />
        }
        return (
          <ContextMenuItem
            key={i}
            onSelect={action.onSelect}
            disabled={action.disabled}
          >
            <span className="mr-2">{action.icon}</span>
            {action.label}
          </ContextMenuItem>
        )
      })}
    </>
  )
}
